import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import * as turf from '@turf/turf'
/**
 * 风险区域图层
 */
export default class RiskAreaLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.RISKAREA;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.map((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            item.coords=Array.isArray(item.coords) ? item.coords:JSON.parse(item.coords||"[]");
            if(item.coords.length > 0){
                let positions=[],coordinates=[];
                for(let coord of item.coords){
                    coordinates.push([Number(coord[0]),Number(coord[1])]);
                    positions.push(Cesium.Cartesian3.fromDegrees(Number(coord[0]),Number(coord[1]), CONSTANTS.ALTITUDE));
                }
                let centroid = turf.getCoord(turf.centroid(turf.polygon([coordinates])));//获取线段中心点
                let entity = new Cesium.Entity({
                    id:item.id,
                    attributes:item,
                    position:Cesium.Cartesian3.fromDegrees(centroid[0],centroid[1]),
                    polygon: {
                        hierarchy: positions,
                        extrudedHeight: item.height||15,
                        material:Cesium.Color.fromCssColorString(item.color||"#ff0000").withAlpha(0.5),
                        closeTop: true,
                        closeBottom: true
                    },
                    label:{
                        text : item.riskName,
                        font: "16px Helvetica",
                        fillColor: Cesium.Color.WHITE,
                        outlineColor: Cesium.Color.BLACK,
                        outlineWidth: 2,
                        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                        showBackground: false,
                        //垂直位置
                        //verticalOrigin : Cesium.VerticalOrigin.BUTTON,
                        //中心位置
                        pixelOffset : new Cesium.Cartesian2(0, -30),
                        //解决绘制几何图形被高程遮挡
                        disableDepthTestDistance:Number.POSITIVE_INFINITY,
                        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 35000)
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });
    }
};
